/**
 * The only copy that lives in code.
 *
 * Everything a visitor reads comes from the CMS, with one unavoidable
 * exception: the screens shown when that copy is missing or unreachable.
 * They cannot read the thing that failed to load, so their few strings are
 * literals here. Keep this file small — anything an editor might want to
 * change belongs in the CMS.
 */
export const shellCopy = {
  /** Shown while the first copy fetch is in flight and nothing is cached. */
  loading: 'Loading…',

  /** Shown when copy cannot be fetched and nothing is cached. */
  unavailableTitle: 'Cannot load the site',
  unavailableBody:
    'The content service could not be reached. Check your connection and try again.',
  retry: 'Try again',

  /** react-router error boundaries, which can render outside the providers. */
  routeErrorTitle: 'Something went wrong',
  routeErrorBody:
    'An unexpected error occurred while rendering this page. Reloading usually fixes it.',
  reload: 'Reload Page',
  notFoundTitle: '404 - Page not found',
  notFoundBody:
    'The page you are looking for does not exist or has been moved.',
  backHome: 'Back to home',
} as const;
